import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import {
  Box,
  styled,
} from "@mui/material";
import FormSection from "controls/global/form-section";
import {
  ActionType,
  useSideNavProvider
} from "pages/file/SideNavProvider";
import React, {
  useEffect,
} from "react";
import {
  colors,
  fontSize,
  fontFamily,
  fontWeight,
  gradients,
  margin,
  padding,
} from "theme/defaultStyle";
import useFormWrapper from "utils/custom-hooks/useFormWrapper";
import { useProfileSettingsCache } from "utils/context/ProfileSettingsContext";
import FileHistory from "./FileHistory";

const Container = styled("div")({
  margin: margin.zero,
  maxHeight: 630,
  overflowY: "auto",
  "& .MuiContainer-root": {
    margin: margin.zero,
    padding: padding.zero,
  },
  "& .MuiBox-root": {
    margin: margin.zero,
    padding: padding.zero,
  },
});

const StyledVisibilityMessage = styled("div")({
  color: colors.grey11,
  fontFamily: fontFamily.primary,
  fontSize: fontSize.large,
  fontWeight: fontWeight.normal1,
  paddingTop: padding.large2,
});

const StyledIcon = styled(HistoryRoundedIcon)({
  color: colors.white,
  fontSize: `${fontSize.xlarge0} !important`,
});

const StyledWrapper = styled(Box)({
  borderRadius: "50%",
  background: gradients.maroonGradient01,
  display: "flex",
  justifyContent: "center",
  padding: padding.xsmall,
  paddingLeft: padding.zero,
});

const FileInfo = ({key}: { key: number}) => {
  const { getValues } = useFormWrapper();
  const activities = getValues("fileActivities");
  const [{ profileSettings }] = useProfileSettingsCache();
  const { sideNavState, sideNavAction } = useSideNavProvider();
  const fileHistoryRef = React.useRef<HTMLElement>();

  const shouldShowSection = activities?.length;

  const fileHistory = (
    <>
      <Container key="fileActivities">
        <FileHistory records={activities} />
      </Container>
      {profileSettings?.isStaffUser === 1 && (
        <StyledVisibilityMessage>* This activity is visible to Stewart staff only.</StyledVisibilityMessage>
      )}
    </>
  );

  const WrapperHistoryRoundedIcon = () => {
    return (
      <StyledWrapper>
        <StyledIcon />
      </StyledWrapper>
    );
  };

  useEffect(() => {
    if (shouldShowSection) {
      if (sideNavState.items.get("File History")?.childRef?.current) return;
      sideNavAction({
        type: ActionType.UPDATE,
        item: { name: "File History", childRef: fileHistoryRef },
      });
    } else {
      sideNavAction({
        type: ActionType.UPDATE,
        item: { name: "File History", childRef: undefined },
      });
    }
  }, [shouldShowSection, sideNavState.items]);

  if (!shouldShowSection) return null;

  return (
    <FormSection
      navItemRef={fileHistoryRef}
      data-test="fileInfo"
      icon={<WrapperHistoryRoundedIcon />}
      title="File History"
    >
      {fileHistory}
    </FormSection>
  );
};

export default FileInfo;
